import { Cartesian2, Cesium3DTileColorBlendMode, Cesium3DTileFeature, Cesium3DTileStyle, Color, KeyboardEventModifier, ScreenSpaceEventHandler, ScreenSpaceEventType, Math as MathCesium, Cartographic, HeadingPitchRange } from "cesium";
import { colorElementDefault, colorIsolate, createUUID, createBoundingSphereFromLatLonBounds } from "../utils/utils";
import '../styles/contextMenu.css';
import { ObjDataPrimitiveModel } from "src/interfaces/styleElement.interface";
import { InputDataPrimitive } from "./styleElement";
import { LayerModelNew } from "./layerModelNew";
import { SelectedObjectInfo } from "../interfaces/dpuViewer.interface";


interface ClickHightLight {
    feature: any;
    color: Color;
    originalColorBlendMode?: Cesium3DTileColorBlendMode;
    pickId: string;
    guid?: string;
    batchId?: string;
    fileName?: string;
}

export class ContextMenu {
    viewer: any;
    containerId: string;
    IdGenneral = createUUID(); // Tạo ID ngẫu nhiên khi khởi tạo
    opacityClick: number = 1
    layerModel: LayerModelNew | undefined
    private _hexColorPick = "#00cc44";
    private handler: any
    private isIsolating: boolean = false;
    private isShowOff: boolean = false;
    private contextMenu: HTMLElement | null = null;
    private _boxDrag: HTMLElement | null = null
    listPicked: any[] = []; // Mảng để lưu các đối tượng đã chọn
    private _inputDataPrimitive: InputDataPrimitive
    private onSelectionChangedCallback: ((selectedIds: SelectedObjectInfo[]) => void) | undefined = undefined;
    constructor(containerId: string, viewer: any, inputDataPrimitive: InputDataPrimitive) {
        this.containerId = containerId;  // Gán giá trị containerId    
        this.viewer = viewer;  // Gán giá trị viewer
        this._inputDataPrimitive = inputDataPrimitive

        this.createContextMenu()
    }
    //#region createContextMenu
    createContextMenu = () => {
        this.addEscKeyListener();
        this._handeListenEventKeyBoard();
        const containerId = document.querySelector(`#${this.containerId}`) as HTMLElement;

        this.contextMenu = document.createElement('div');
        this.contextMenu.classList.add('cesium-context-menu'); // Gán class cho contextMenu
        containerId?.appendChild(this.contextMenu);

        this._boxDrag = document.createElement('div');
        this._boxDrag.classList.add('box-drag-element')
        containerId?.appendChild(this._boxDrag);


        let isLeftClickHeld = false; // Biến để theo dõi trạng thái chuột trái
        let isRightClickHeld = false; // Biến để theo dõi trạng thái chuột phải

        let start: any, end: any
        // Tạo bộ xử lý sự kiện cho chuột trái
        this.handler = new ScreenSpaceEventHandler(this.viewer.scene.canvas);

        this.handler.setInputAction((movement: any) => {
            const cartesian = this.viewer.scene.camera.pickEllipsoid(
                movement.position,
                this.viewer.scene.globe.ellipsoid
            );
            this._shareLongLat(cartesian);

            // Đóng context menu nếu đang mở
            if (this.contextMenu!.style.display === 'block') {
                this.contextMenu!.style.display = 'none';
            }


            // Xác định vị trí của context menu
            this.contextMenu!.style.left = `${movement.position.x}px`;
            this.contextMenu!.style.top = `${movement.position.y}px`;
            // Chọn đối tượng và thay đổi màu sắc của nó
            // if (this.picked && (this.picked instanceof Cesium3DTileFeature && this.picked || this.picked.primitive! instanceof Cesium3DTileset && this.picked)) {
            //Hiện context menu
            if (this.listPicked.length > 0) {
                this.contextMenu!.innerHTML = `
                    <ul>
                    <li data-item="isolate-${this.IdGenneral}">Isolate</li>          
                    <li data-item="show-off-${this.IdGenneral}">Hide</li>
                    <li data-item="show-all-${this.IdGenneral}">Show All</li>     
                    <li data-item="focus-${this.IdGenneral}">Focus</li>
                    </ul>
                `;
            } else {
                this.contextMenu!.innerHTML = `
                    <ul>

                        <li data-item="show-all-${this.IdGenneral}">Show All</li>     
                    </ul>
                `;
            }

            if (this.isShowOff && this.listPicked.length == 0) {
                this.contextMenu!.innerHTML = `
                <ul>

                    <li data-item="show-all-${this.IdGenneral}">Show All</li>     
                </ul>
            `;
            }
            this.contextMenu!.style.display = 'block';




            // Lắng nghe sự kiện click cho từng item trong menu
            this.addMenuEventListeners(this.contextMenu!);
            this.viewer.scene.requestRender();

        }, ScreenSpaceEventType.RIGHT_CLICK);

        this.handler.setInputAction((movement: any) => {
            // Lấy vị trí pixel chuột
            const position = movement.position;
            // Pick vật thể tại vị trí chuột
            const picked = this.viewer.scene.pick(position);



            if (picked instanceof Cesium3DTileFeature && picked) {
                // this.isIsolate = true;
                if (!this._checkPickElementIsolate(picked)) {
                    this._handlePickedCesium(picked, false)
                } else {
                    const pickedObjects = this.viewer.scene.drillPick(movement.position);
                    for (const pickedObj of pickedObjects) {
                        if (pickedObj instanceof Cesium3DTileFeature) {

                            if (!this._checkPickElementIsolate(pickedObj)) {
                                this._handlePickedCesium(pickedObj, false)
                                break; // Thoát vòng lặp ngay khi gặp đối tượng phù hợp
                            } else {
                                this._handleResetAllColor()

                            }
                        }
                    }
                }
            } else {
                this._handleResetAllColor()

            }
            this.viewer.scene.requestRender();
            this.notifySelectionChanged();

        }, ScreenSpaceEventType.LEFT_CLICK);


        this.handler.setInputAction((movement: any) => {

            // Lấy vị trí pixel chuột
            const position = movement.position;
            const pickedCtrl = this.viewer.scene.pick(position);
            if (pickedCtrl instanceof Cesium3DTileFeature && pickedCtrl) {
                if (!this._checkPickElementIsolate(pickedCtrl)) {
                    this._handlePickedCesium(pickedCtrl, true)
                } else {
                    const pickedObjects = this.viewer.scene.drillPick(movement.position);
                    for (const pickedObj of pickedObjects) {
                        if (pickedObj instanceof Cesium3DTileFeature) {

                            if (!this._checkPickElementIsolate(pickedObj)) {
                                this._handlePickedCesium(pickedObj, true)
                                break; // Thoát vòng lặp ngay khi gặp đối tượng phù hợp
                            } else {
                                this._handleResetAllColor()

                            }
                        }
                    }
                }
            }
            this.getObjsIdsPicked()

            this.viewer.scene.requestRender();
            this.notifySelectionChanged();

        }, ScreenSpaceEventType.LEFT_CLICK, KeyboardEventModifier.CTRL)



        // Lắng nghe sự kiện di chuyển chuột (mousemove) để tắt context menu
        this.handler.setInputAction((movement: any) => {
            // Tắt context menu nếu chuột di chuyển trong khi giữ chuột phải hoặc trái
            if (isLeftClickHeld || isRightClickHeld) {
                this.contextMenu!.style.display = 'none';
            }

        }, ScreenSpaceEventType.MOUSE_MOVE);



        this.handler.setInputAction((movement: any) => {

            isLeftClickHeld = true;



        }, ScreenSpaceEventType.LEFT_DOWN);


        this.handler.setInputAction((movement: any) => {

            isLeftClickHeld = false;
        }, ScreenSpaceEventType.LEFT_UP);



        this.handler.setInputAction((movement: any) => {

            isRightClickHeld = true;
        }, ScreenSpaceEventType.RIGHT_DOWN);


        this.handler.setInputAction((movement: any) => {

            isRightClickHeld = false;


        }, ScreenSpaceEventType.RIGHT_UP);

        //#region Drag Mouse
        this.handler.setInputAction((movement: any) => {
            start = Cartesian2.clone(movement.position, new Cartesian2());
            this._boxDrag!.style.left = start.x + 'px';
            this._boxDrag!.style.top = start.y + 'px';
            this._boxDrag!.style.width = '0px';
            this._boxDrag!.style.height = '0px';
            this._boxDrag!.style.display = 'block';

            this._handleResetAllColor()

        }, ScreenSpaceEventType.LEFT_DOWN, KeyboardEventModifier.ALT);

        this.handler.setInputAction((movement: any) => {
            if (!start) return;

            end = movement.endPosition;
            const xMin = Math.min(start.x, end.x);
            const xMax = Math.max(start.x, end.x);
            const yMin = Math.min(start.y, end.y);
            const yMax = Math.max(start.y, end.y);

            this._boxDrag!.style.left = xMin + 'px';
            this._boxDrag!.style.top = yMin + 'px';
            this._boxDrag!.style.width = (xMax - xMin) + 'px';
            this._boxDrag!.style.height = (yMax - yMin) + 'px';
        }, ScreenSpaceEventType.MOUSE_MOVE, KeyboardEventModifier.ALT);

        this.handler.setInputAction((movement: any) => {
            if (!start || !end) {
                start = undefined;
                end = undefined;
                this._boxDrag!.style.display = 'none';
                return;
            }

            const xMin = Math.min(start.x, end.x);
            const xMax = Math.max(start.x, end.x);
            const yMin = Math.min(start.y, end.y);
            const yMax = Math.max(start.y, end.y);

            const centerX = (xMin + xMax) / 2;
            const centerY = (yMin + yMax) / 2;
            const width = xMax - xMin;
            const height = yMax - yMin;

            if (width > 3 && height > 3) {
                // console.log("1111");
                // Sử dụng drillPick với vùng chọn
                const pickedObjects = this.viewer.scene.drillPick(new Cartesian2(centerX, centerY), undefined, width, height);


                pickedObjects.forEach((pickedObject: any) => {
                    if (pickedObject.pickId && !this._checkPickElementIsolate(pickedObject)) {
                        // Lấy thuộc tính Guid để kiểm tra
                        const targetBatchIdProperty = pickedObject.getProperty("Guid");
                        const findItem = this.listPicked.find((x: any) => x.guid === targetBatchIdProperty)
                        if (!findItem) {
                            this._handlePickedCesium(pickedObject, true)
                        }

                    }
                });
            }
            // Reset trạng thái
            start = undefined;
            end = undefined;
            this._boxDrag!.style.display = 'none';

            this.viewer.scene.requestRender();
            this.notifySelectionChanged();

        }, ScreenSpaceEventType.LEFT_UP, KeyboardEventModifier.ALT);


        // Đóng menu khi nhấn chuột trái ra ngoài
        document.addEventListener('click', (event: any) => {
            if (!this.contextMenu!.contains(event.target)) {
                this.contextMenu!.style.display = 'none';
            }
        });
    };

    //#region handlePickedCesium
    private _handlePickedCesium = (picked: any, ctrlPick: boolean = false) => {
        // Lấy thuộc tính Guid để áp dụng cho các đối tượng cùng nhóm
        const targetBatchIdProperty = picked.getProperty("BatchId");
        const targetFilenameProperty = picked.getProperty("Filename");
        const targetGuidProperty = picked.getProperty("Guid");
        // console.log("picked",picked);
        // console.log("targetProperty",targetProperty);
        if (!ctrlPick) {
            // Reset lại tất cả màu khi không nhấn Ctrl
            this._handleResetAllColor();

        } else {

            // Tìm tất cả các đối tượng trong danh sách có Guid giống với đối tượng được chọn
            const elementsToRemove = this.listPicked.filter(
                (feature) => feature.guid === targetGuidProperty
            );
            // Reset lại màu cho tất cả các đối tượng bị xóa
            this._handelResetColor(elementsToRemove);
            // Nếu có bất kỳ đối tượng nào đã được chọn và nhấn Ctrl + Click
            if (elementsToRemove.length > 0) {
                // Duyệt qua danh sách và xóa các phần tử có cùng Guid
                for (let i = this.listPicked.length - 1; i >= 0; i--) {
                    if (this.listPicked[i].guid === targetGuidProperty) {
                        // Xóa phần tử khỏi listPicked
                        this.listPicked.splice(i, 1);


                    }
                }
                return

            }
        }


        // Nếu chưa có, thêm đối tượng vào danh sách
        let clonedColor = Color.clone(picked.color);
        let newClickHighLight: ClickHightLight = {
            feature: picked,
            color: clonedColor,
            originalColorBlendMode: picked.primitive.colorBlendMode,
            pickId: (picked as any).pickId,
            batchId: targetBatchIdProperty,
            fileName: targetFilenameProperty,
            guid: targetGuidProperty // Thêm trường guid (tuỳ chọn hoặc bắt buộc tuỳ vào logic)
        };

        this.listPicked.push(newClickHighLight);
        picked.color = Color.fromCssColorString(this._hexColorPick).withAlpha(this.opacityClick);
        picked.primitive.colorBlendMode = 1;

        const content = (picked as any).content;
        for (let k = 0; k < content.featuresLength; k++) {
            if (k != picked.featureId) {
                const feature = content.getFeature(k);
                const featureContentGuid = feature.getProperty("Guid")
                const featureContentBatchId = feature.getProperty("BatchId")
                const featureContentFilename = feature.getProperty("Filename")
                if (featureContentGuid === targetGuidProperty) {
                    clonedColor = Color.clone(feature.color);

                    feature.color = Color.fromCssColorString(this._hexColorPick).withAlpha(this.opacityClick);
                    newClickHighLight = {
                        feature: feature,
                        color: clonedColor,
                        originalColorBlendMode: feature.primitive.colorBlendMode,
                        pickId: (picked as any).pickId,
                        guid: featureContentGuid,
                        batchId: featureContentBatchId,
                        fileName: featureContentFilename
                    };
                    this.listPicked.push(newClickHighLight);
                }
            }
        }


    };
    //#region _checkPickElementIsolate
    private _checkPickElementIsolate = (pick: any) => {
        let pickIsolate = false
        const rgbaColor = `rgba(${Math.round(pick.color.red * 255)}, ${Math.round(pick.color.green * 255)}, ${Math.round(pick.color.blue * 255)}, ${pick.color.alpha.toFixed(2)})`;
        const rgbaNoSpaces = rgbaColor.replace(/\s+/g, '');
        if (rgbaNoSpaces === colorIsolate.replace(/\s+/g, '')) {
            pickIsolate = true
        }
        return pickIsolate
    }


    private _handleResetAllColor = () => {
        // Reset colors for picked features, with defensive checks
        try {
            for (let i = 0; i < this.listPicked.length; ++i) {
                const item = this.listPicked[i];
                if (!item || !item.feature) continue;
                try {
                    if (item.color && item.feature) {
                        item.feature.color = item.color;
                    }
                    if (item.originalColorBlendMode !== undefined && item.feature.primitive) {
                        item.feature.primitive.colorBlendMode = item.originalColorBlendMode;
                    }
                } catch (innerErr) {
                    // ignore per-item errors and continue
                }
            }
        } catch (error) {
            // swallow errors to avoid breaking callers (defensive)
        }

        this.listPicked = [];

    }

    private _handelResetColor = (listElement: any[]) => {
        listElement.forEach((item) => {
            // Reset lại màu về màu gốc
            item.feature.color = item.color;
            // Reset lại chế độ blend màu gốc
            item.feature.primitive.colorBlendMode = item.originalColorBlendMode;
        });
    };



    private _handleEscPress = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            this._handleResetAllColor()
            this.contextMenu!.style.display = 'none';
            this.viewer.scene.requestRender();
            this.notifySelectionChanged();


        }
    }

    addEscKeyListener = () => {
        document.addEventListener('keydown', this._handleEscPress);
        // console.log('Sự kiện ESC đã được thêm');
    }
    removeEscKeyListener = () => {
        document.removeEventListener('keydown', this._handleEscPress);
        // console.log('Sự kiện ESC đã bị hủy');
    }

    // Hàm xử lý sự kiện click menu
    private addMenuEventListeners = (contextMenu: HTMLElement) => {
        const items = contextMenu.querySelectorAll('li');
        items.forEach((item) => {
            item.addEventListener('click', (event) => {
                const dataItem = item.getAttribute('data-item');
                // Xử lý logic cho các menu item tại đây (ví dụ: isolate, show off, show all)
                if (dataItem === `focus-${this.IdGenneral}`) {
                    // Thực hiện hành động "Focus"
                    this.contextMenu_Focus()
                }
                if (dataItem === `isolate-${this.IdGenneral}`) {
                    // Thực hiện hành động "Isolate"
                    this.contextMenu_Isolate()
                }
                if (dataItem === `show-off-${this.IdGenneral}`) {
                    // Thực hiện hành động "Show Off"
                    this.contextMenu_ShowOff()
                }
                if (dataItem === `show-all-${this.IdGenneral}`) {
                    // Thực hiện hành động "Show All"
                    this.contextMenu_ShowAll(contextMenu);
                }
            });
        });

    };

    contextMenu_Focus = () => {
        if (this.listPicked.length === 0) return;

        const targetGuid = this.listPicked[0].guid;
        if (!targetGuid) return;

        const listKeyMapObject = this.layerModel?.listKeyMapObject;
        if (!listKeyMapObject) return;

        const targetData = listKeyMapObject[targetGuid];
        if (!targetData || !targetData.objectConnects) return;

        const pointObj = this.layerModel?.computeBoundingBoxFromFeatureObjects(targetData.objectConnects);
        if (!pointObj) return;

        const url = targetData.primitive?.resource?.url;
        const originalBoundingBox = targetData.originalBoundingBox;
        const disparityCood = (this.layerModel as any)._handleDisparityCoord(url, originalBoundingBox);

        const minPoint: [number, number, number] = [
            pointObj.minPoint[0] + disparityCood[1],
            pointObj.minPoint[1] + disparityCood[0],
            pointObj.minPoint[2] + disparityCood[2]
        ];
        const maxPoint: [number, number, number] = [
            pointObj.maxPoint[0] + disparityCood[1],
            pointObj.maxPoint[1] + disparityCood[0],
            pointObj.maxPoint[2] + disparityCood[2]
        ];

        const boundingSphere = createBoundingSphereFromLatLonBounds(minPoint, maxPoint);

        const pitch = this.viewer.camera.pitch;
        const roll = this.viewer.camera.roll;
        const heading = this.viewer.camera.heading;

        const offset = new HeadingPitchRange(
            heading,
            pitch,
            boundingSphere.radius * 2
        );

        this.viewer.camera.flyToBoundingSphere(boundingSphere, {
            duration: 1.0,
            offset: offset,
            complete: () => {
                this.viewer.camera.setView({
                    orientation: {
                        heading: this.viewer.camera.heading,
                        pitch: this.viewer.camera.pitch,
                        roll: roll
                    }
                });
            }
        });

        if (this.contextMenu) {
            this.contextMenu.style.display = 'none';
        }
    };



    private objectIsolates: any = []
    conditionsIsolate: [string, string][] = []
    conditionForShowOff: [string, string][] = []

    //#region Isolate    

    tempCondition: {
        conditionColor?: any,
        conditionShow?: any,
        listPicked?: any
    } = {}
    isLoadFromShow: boolean = false
    // contextMenu_Isolate = () => {
    //     // Kiểm tra nếu có đối tượng trong listPicked

    //     try {
    //         const primitives = this.viewer.scene.primitives._primitives;

    //         this.isIsolating = true;

    //         if (!this.isLoadFromShow) {
    //             this.conditionsIsolate = []
    //             const pickedBatchIds = this.listPicked.map(picked => picked.feature.getProperty("BatchId"));
    //             const pickedFileNames = this.listPicked.map(picked => picked.feature.getProperty("Filename"));
    //             const pickedGuids = this.listPicked.map(picked => picked.feature.getProperty("Guid"));
    //             // if(!pickedBatchIds||!pickedFileNames||!pickedGuids) return
    //             for (let i = 0; i < pickedBatchIds.length; i++) {
    //                 this.objectIsolates.push([pickedBatchIds[i], pickedFileNames[i], pickedGuids[i]]);
    //             }

    //             // Duyệt qua danh sách objectOffs
    //             for (let i = 0; i < this.objectIsolates.length; i++) {
    //                 const [batchId, fileName, guid] = this.objectIsolates[i];
    //                 // Thêm điều kiện vào danh sách
    //                 this.conditionsIsolate.push([`\${batchId}===${batchId}&&\${fileName}==='${fileName}'&&\${guid}==='${guid}'`, 'color("rgba(255,255,255,1)")']);
    //             }

    //             // Điều kiện 2: Đối tượng không thỏa mãn điều kiện trên sẽ có độ trong suốt 50%
    //             this.conditionsIsolate.push(["true", `color("${colorIsolate}")`]);    // Đổi màu với alpha 0.5`
    //         }


    //         for (let i = 0; i < primitives.length; ++i) {
    //             if (primitives[i].style) {
    //                 this._inputDataPrimitive.ObjDataPrimitive.forEach((objData: ObjDataPrimitiveModel) => {
    //                     if (primitives[i].resource && primitives[i].resource.url && primitives[i].resource.url === objData.primitive.resource.url) {
    //                         if ((objData.conditionColors ?? []).length > 0) {


    //                             let updatedConditions = [...this.conditionsIsolate];  // Sao chép list1 vào newList để không thay đổi list1

    //                             // Tìm phần tử "true" trong objData.conditionColors
    //                             let trueItemInConditionColors = objData.conditionColors?.find(item => item[0] === "true");

    //                             // Nếu có phần tử "true" trong objData.conditionColors
    //                             if (trueItemInConditionColors) {
    //                                 // Duyệt qua từng phần tử trong updatedConditions
    //                                 updatedConditions.forEach((condition: [string, string], index: number) => {
    //                                     // Nếu phần tử không phải "true"
    //                                     if (condition[0] !== "true") {
    //                                         // Kiểm tra xem phần tử có tồn tại trong objData.conditionColors không
    //                                         let foundInConditionColors = objData.conditionColors?.find(item => item[0] === condition[0]);

    //                                         // Nếu không tìm thấy phần tử trong objData.conditionColors, thay màu từ "true"
    //                                         if (!foundInConditionColors) {
    //                                             updatedConditions[index][1] = trueItemInConditionColors[1];  // Gán màu từ "true"
    //                                         } else {
    //                                             // Nếu tìm thấy phần tử trong objData.conditionColors, thay màu sắc của phần tử
    //                                             updatedConditions[index][1] = foundInConditionColors[1];
    //                                         }
    //                                     }
    //                                 });
    //                             } else {
    //                                 // Nếu không có phần tử "true" trong objData.conditionColors, duyệt qua objData.conditionColors
    //                                 objData.conditionColors?.forEach((conditionColor: [string, string]) => {
    //                                     // Kiểm tra nếu phần tử không phải "true"
    //                                     if (conditionColor[0] !== "true") {
    //                                         // Kiểm tra xem phần tử có trong updatedConditions không
    //                                         let index = updatedConditions.findIndex(item1 => item1[0] === conditionColor[0]);

    //                                         // Nếu phần tử có trong updatedConditions, thay thế màu sắc từ objData.conditionColors
    //                                         if (index !== -1) {
    //                                             updatedConditions[index][1] = conditionColor[1];
    //                                         }
    //                                     }
    //                                 });
    //                             }

    //                             objData.primitive.style = new Cesium3DTileStyle({
    //                                 defines: {
    //                                     batchId: "${feature['BatchId']}",
    //                                     fileName: "${feature['Filename']}",
    //                                     guid: "${feature['Guid']}",
    //                                 },

    //                                 color: {
    //                                     conditions: updatedConditions,
    //                                 },
    //                             });
    //                             this.tempCondition.conditionColor = updatedConditions
    //                             this.tempCondition.listPicked = this.listPicked

    //                             // this.isolateObj.push(objData.primitive)
    //                             // console.log("objData.primitive 1 ", objData.primitive);
    //                         } else {

    //                             primitives[i].style = new Cesium3DTileStyle({
    //                                 defines: {
    //                                     batchId: "${feature['BatchId']}",
    //                                     fileName: "${feature['Filename']}",
    //                                     guid: "${feature['Guid']}",
    //                                 },
    //                                 color: {
    //                                     conditions: this.conditionsIsolate
    //                                 },
    //                             });
    //                             this.tempCondition.conditionColor = this.conditionsIsolate
    //                             this.tempCondition.listPicked = this.listPicked
    //                             // console.log("objData.primitive 2 ", primitives[i]);

    //                         }
    //                     }
    //                 })
    //             } else {
    //                 //Trường hợp đầu tiên
    //                 primitives[i].style = new Cesium3DTileStyle({
    //                     defines: {
    //                         batchId: "${feature['BatchId']}",
    //                         fileName: "${feature['Filename']}",
    //                         guid: "${feature['Guid']}",
    //                     },
    //                     color: {
    //                         conditions: this.conditionsIsolate
    //                     },
    //                 });

    //                 this.tempCondition.conditionColor = this.conditionsIsolate
    //                 this.tempCondition.listPicked = this.listPicked
    //             }

    //         }

    //         this._handleResetAllColor()

    //         this.objectIsolates = []

    //         if (!this.isLoadFromShow) {
    //             this.conditionForShowOff = [...this.conditionsIsolate]
    //         }

    //         this.conditionsIsolate = []

    //     } catch (error) {
    //         this.isIsolating = false;
    //         console.error('Error isolating features:', error);
    //     }

    //     this.viewer.scene.requestRender();


    //     if (this.contextMenu) {
    //         // Ẩn menu context
    //         this.contextMenu.style.display = 'none';
    //     }
    // };
    //#region contextMenu_Isolate
    contextMenu_Isolate = () => {
        try {
            const primitives = this.viewer.scene.primitives._primitives;
            this.isIsolating = true;

            if (!this.isLoadFromShow) {
                this.conditionsIsolate = [];
                const pickedBatchIds = this.listPicked.map(picked => picked.feature.getProperty("BatchId"));
                const pickedFileNames = this.listPicked.map(picked => picked.feature.getProperty("Filename"));
                const pickedGuids = this.listPicked.map(picked => picked.feature.getProperty("Guid"));
                for (let i = 0; i < pickedBatchIds.length; i++) {
                    this.objectIsolates.push([pickedBatchIds[i], pickedFileNames[i], pickedGuids[i]]);
                }
                for (let i = 0; i < this.objectIsolates.length; i++) {
                    const [batchId, fileName, guid] = this.objectIsolates[i];
                    this.conditionsIsolate.push([`\${batchId}===${batchId}&&\${fileName}==='${fileName}'&&\${guid}==='${guid}'`, `color("${colorElementDefault}")`]);
                }
                this.conditionsIsolate.push(["true", `color("${colorIsolate}")`]);
            }

            // Tạo map tra cứu ObjDataPrimitive theo resource.url
            const objDataMap = new Map<string, ObjDataPrimitiveModel>();
            this._inputDataPrimitive.ObjDataPrimitive.forEach((objData: ObjDataPrimitiveModel) => {
                const url = objData.primitive.resource?.url;
                if (url) objDataMap.set(url, objData);
            });
            this.tempCondition.conditionColor = this.conditionsIsolate.map(item => [...item]);
            this.tempCondition.listPicked = this.listPicked.map((item: any) => ({ ...item }));
            if (!this.isLoadFromShow) {
                this.conditionForShowOff = this.conditionsIsolate.map(item => [...item]);
            }
            // --- Web Worker Blob for Isolate style calculation ---
            function workerFunction() {
                self.onmessage = function (e) {
                    const { primitives, objDataPrimitive, conditionsIsolate } = e.data;
                    const results = [];
                    // Tạo map tra cứu ObjDataPrimitive theo resource.url
                    const objDataMap = new Map();
                    objDataPrimitive.forEach((objData: ObjDataPrimitiveModel) => {
                        const url = objData.primitive.resource?.url;
                        if (url) objDataMap.set(url, objData);
                    });
                    for (let i = 0; i < primitives.length; ++i) {
                        const primitive = primitives[i];
                        const url = primitive.resource?.url;
                        let styleData = null;
                        if (primitive.style && url && objDataMap.has(url)) {
                            const objData = objDataMap.get(url);

                            if ((objData.conditionColors ?? []).length > 0) {
                                // Tạo bản sao sâu cho mỗi primitive để tránh ghi đè giữa các vòng lặp
                                let updatedConditions = conditionsIsolate.map((item: any) => [...item]);

                                let trueItemInConditionColors = objData.conditionColors?.find((item: [string, string]) => item[0] === "true");
                                if (trueItemInConditionColors) {
                                    updatedConditions.forEach((condition: string[], index: string | number) => {
                                        if (condition[0] !== "true") {
                                            let foundInConditionColors = objData.conditionColors?.find((item: [string, string]) => item[0] === condition[0]);


                                            if (foundInConditionColors) {
                                                updatedConditions[index][1] = foundInConditionColors[1];
                                            } else {
                                                updatedConditions[index][1] = trueItemInConditionColors[1];  // Gán màu từ "true"
                                            }
                                            // Nếu không tìm thấy thì giữ nguyên, KHÔNG gán trueItemInConditionColors[1]
                                        }
                                    });
                                } else {
                                    objData.conditionColors?.forEach((conditionColor: any) => {
                                        if (conditionColor[0] !== "true") {
                                            let index = updatedConditions.findIndex((item1: any[]) => item1[0] === conditionColor[0]);
                                            if (index !== -1) {
                                                updatedConditions[index][1] = conditionColor[1];
                                            }
                                        }
                                    });
                                }


                                styleData = {
                                    defines: {
                                        batchId: '\${feature["BatchId"]}',
                                        fileName: '\${feature["Filename"]}',
                                        guid: '\${feature["Guid"]}'
                                    },
                                    color: { conditions: updatedConditions }
                                };
                            } else {

                                styleData = {
                                    defines: {
                                        batchId: '\${feature["BatchId"]}',
                                        fileName: '\${feature["Filename"]}',
                                        guid: '\${feature["Guid"]}'
                                    },
                                    color: { conditions: conditionsIsolate }
                                };
                            }
                        } else if (!primitive.style) {

                            styleData = {
                                defines: {
                                    batchId: '\${feature["BatchId"]}',
                                    fileName: '\${feature["Filename"]}',
                                    guid: '\${feature["Guid"]}'
                                },
                                color: { conditions: conditionsIsolate }
                            };
                        }


                        results.push({ primitiveIndex: i, styleData });
                    }
                    self.postMessage(results);
                };
            }
            // Tạo worker blob
            const workerCode = `(${workerFunction.toString()})()`;
            const blob = new Blob([workerCode], { type: 'application/javascript' });
            const worker = new Worker(URL.createObjectURL(blob));
            // Chuẩn bị dữ liệu serializable
            worker.postMessage({
                primitives: primitives.map((p: any) => ({
                    resource: p.resource ? { url: p.resource.url } : null,
                    style: !!p.style
                })),
                objDataPrimitive: this._inputDataPrimitive.ObjDataPrimitive.map((obj) => ({
                    primitive: { resource: obj.primitive.resource ? { url: obj.primitive.resource.url } : null },
                    conditionColors: obj.conditionColors
                })),
                conditionsIsolate: this.conditionsIsolate
            });
            worker.onmessage = (e) => {
                const result = e.data;
                // Chia primitives thành nhiều nhóm, mỗi nhóm xử lý bởi một worker nhỏ
                const WORKER_COUNT = 8;
                const CHUNK_SIZE = Math.ceil(result.length / WORKER_COUNT);
                let completed = 0;
                const total = result.length;
                function chunkArray<T>(arr: T[], size: number): T[][] {
                    const chunks: T[][] = [];
                    for (let i = 0; i < arr.length; i += size) {
                        chunks.push(arr.slice(i, i + size));
                    }
                    return chunks;
                }
                const resultChunks = chunkArray(result, CHUNK_SIZE);
                for (const chunk of resultChunks) {
                    const chunkWorkerCode = `
                    self.onmessage = function(e) {
                        const { chunk } = e.data;
                        self.postMessage(chunk);
                    };
                `;
                    const chunkBlob = new Blob([chunkWorkerCode], { type: 'application/javascript' });
                    const chunkWorker = new Worker(URL.createObjectURL(chunkBlob));
                    chunkWorker.postMessage({ chunk });
                    chunkWorker.onmessage = (ev) => {
                        const chunkResult = ev.data;
                        let i = 0;
                        const BATCH_SIZE = 4;
                        const applyBatch = () => {
                            let didUpdate = false;
                            for (let b = 0; b < BATCH_SIZE && i < chunkResult.length; b++, i++) {
                                const { primitiveIndex, styleData } = chunkResult[i];
                                if (styleData && primitives[primitiveIndex]) {
                                    const currentStyle = primitives[primitiveIndex].style;
                                    let isDifferent = true;
                                    try {
                                        if (currentStyle && currentStyle._styleOptions) {
                                            isDifferent = JSON.stringify(currentStyle._styleOptions) !== JSON.stringify(styleData);
                                        } else if (currentStyle) {
                                            isDifferent = JSON.stringify(currentStyle) !== JSON.stringify(styleData);
                                        }
                                    } catch (e) {
                                        isDifferent = true;
                                    }
                                    if (isDifferent) {
                                        primitives[primitiveIndex].style = new Cesium3DTileStyle(styleData);
                                    }
                                }
                                completed++;
                                didUpdate = true;
                            }
                            if (completed >= total) {
                                // this.tempCondition.listPicked = this.listPicked;
                                this._handleResetAllColor();
                                this.objectIsolates = [];

                                this.conditionsIsolate = [];
                                this.viewer.scene.requestRender();
                                chunkWorker.terminate();
                            } else if (didUpdate) {
                                requestAnimationFrame(applyBatch);
                            } else {
                                if (completed < total) {


                                    this._handleResetAllColor();
                                    this.objectIsolates = [];

                                    this.conditionsIsolate = [];
                                    this.viewer.scene.requestRender();
                                }
                                chunkWorker.terminate();
                            }
                        };
                        requestAnimationFrame(applyBatch);
                    };
                }
                worker.terminate();
            };

            this._handleResetAllColor();
            this.objectIsolates = [];
            if (!this.isLoadFromShow) {
                this.conditionForShowOff = [...this.conditionsIsolate];
            }
            this.conditionsIsolate = [];
        } catch (error) {
            this.isIsolating = false;
            console.error('Error isolating features:', error);
        }

        this.viewer.scene.requestRender();

        if (this.contextMenu) {
            this.contextMenu.style.display = 'none';
        }
    };

    private objectOffs: any = []
    conditionShowOff: [string, string][] = [];


    //#region showOff

    contextMenu_ShowOff = () => {
        this.isShowOff = true;
        this.conditionShowOff.pop();
        if (!this.isLoadFromShow) {
            const pickedBatchIds = this.listPicked.map(picked => picked.feature.getProperty("BatchId"));
            const pickedFileNames = this.listPicked.map(picked => picked.feature.getProperty("Filename"));
            const pickedGuids = this.listPicked.map(picked => picked.feature.getProperty("Guid"));
            for (let i = 0; i < pickedBatchIds.length; i++) {
                this.objectOffs.push([pickedBatchIds[i], pickedFileNames[i], pickedGuids[i]]);
            }
            for (let i = 0; i < this.objectOffs.length; i++) {
                const [batchId, fileName, guid] = this.objectOffs[i];
                this.conditionShowOff.push([`\${batchId}===${batchId}&&\${fileName}==='${fileName}'&&\${guid}==='${guid}'`, 'false']);
            }
            this.layerModel?.handleHideElement(pickedGuids);
            this.conditionShowOff.push(['true', 'true']);
        }
        const primitives = this.viewer.scene.primitives._primitives;

        this.tempCondition.conditionShow = this.conditionShowOff.map(item => [...item]);


        function workerFunction() {
            self.onmessage = function (e) {
                const { primitives, objDataPrimitive, conditionForShowOff, conditionShowOff, colorIsolate, colorElementDefault, isIsolating, _firstShowAll } = e.data;
                const results = [];
                for (let i = 0; i < primitives.length; ++i) {
                    const primitive = primitives[i];
                    let styleData = null;
                    if (primitive.style) {
                        for (let j = 0; j < objDataPrimitive.length; ++j) {

                            const objData = objDataPrimitive[j];
                            if (primitive.resource && primitive.resource.url && primitive.resource.url === objData.primitive.resource.url) {
                                if (objData.conditionColors && objData.conditionColors.length > 0) {

                                    let compareIsolate: [string, string][] = [];
                                    if (isIsolating) {
                                        compareIsolate = [...conditionForShowOff];
                                        objData.conditionColors.forEach(([key, value]: [string, string]) => {

                                            const existingIndex = compareIsolate.findIndex(([conditionKey]) => conditionKey === key);
                                            if (existingIndex !== -1 && key !== "true") {
                                                compareIsolate[existingIndex][1] = value;
                                            } else if (key === "true") {
                                                compareIsolate.forEach((item, index) => {
                                                    if (item[1] === 'color("' + String(colorElementDefault) + '")') {
                                                        compareIsolate[index][1] = value;
                                                    }
                                                })
                                            }
                                        });

                                        compareIsolate = compareIsolate.filter(item => item[0] !== "true");

                                        const newElement: [string, string] = ["true", 'color("' + String(colorIsolate) + '")'];
                                        const lastElement = compareIsolate[compareIsolate.length - 1];
                                        if (!lastElement || lastElement[0] !== newElement[0] || lastElement[1] !== newElement[1]) {
                                            compareIsolate.push(newElement);
                                        }
                                    } else {
                                        compareIsolate = [...conditionForShowOff];
                                        const map = new Map(compareIsolate.map(([key, value]) => [key, value]));
                                        objData.conditionColors.forEach(([key, value]: [string, string]) => {
                                            map.set(key, value);
                                        });
                                        compareIsolate = Array.from(map.entries());
                                        if (!_firstShowAll) {
                                            objData.conditionIsolates.forEach(([key, value]: [string, string]) => {
                                                map.set(key, value);
                                            });
                                            compareIsolate = Array.from(map.entries());
                                        } else {
                                            const newElement = ["true", 'color("' + String(colorIsolate) + '")'];
                                            const index = compareIsolate.findIndex(([key, value]) => key === newElement[0] && value === newElement[1]);
                                            if (index !== -1) {
                                                compareIsolate.splice(index, 1);
                                            }
                                        }
                                    }
                                    compareIsolate.sort((a, b) => {
                                        if (a[0] === "true") return 1;
                                        if (b[0] === "true") return -1;
                                        return 0;
                                    });
                                    styleData = {
                                        defines: {
                                            batchId: '\${feature["BatchId"]}',
                                            fileName: '\${feature["Filename"]}',
                                            guid: '\${feature["Guid"]}'
                                        },
                                        show: { conditions: conditionShowOff },
                                        color: { conditions: compareIsolate }
                                    };
                                } else {
                                    styleData = {
                                        defines: {
                                            batchId: '\${feature["BatchId"]}',
                                            fileName: '\${feature["Filename"]}',
                                            guid: '\${feature["Guid"]}'
                                        },
                                        show: { conditions: conditionShowOff },
                                        color: { conditions: conditionForShowOff }
                                    };
                                }
                            }
                        }
                    } else {

                        styleData = {
                            defines: {
                                batchId: '\${feature["BatchId"]}',
                                fileName: '\${feature["Filename"]}',
                                guid: '\${feature["Guid"]}'
                            },
                            show: { conditions: conditionShowOff }
                        };
                    }
                    results.push({ primitiveIndex: i, styleData });
                }

                self.postMessage(results);

            };
        }

        // --- Web Worker Blob for style calculation ---
        const workerCode = `(${workerFunction.toString()})()`;


        const blob = new Blob([workerCode], { type: 'application/javascript' });
        const worker = new Worker(URL.createObjectURL(blob));

        // Prepare serializable data
        worker.postMessage({
            primitives: primitives.map((p: any) => ({
                resource: p.resource ? { url: p.resource.url } : null,
                style: !!p.style
            })),
            objDataPrimitive: this._inputDataPrimitive.ObjDataPrimitive.map(obj => ({
                primitive: { resource: obj.primitive.resource ? { url: obj.primitive.resource.url } : null },
                conditionColors: obj.conditionColors,
                conditionIsolates: obj.conditionIsolates
            })),
            conditionForShowOff: this.conditionForShowOff,
            conditionShowOff: this.conditionShowOff,
            colorIsolate,
            colorElementDefault,
            isIsolating: this.isIsolating,
            _firstShowAll: this._firstShowAll
        });

        worker.onmessage = (e) => {
            if (this.contextMenu) {
                this.contextMenu.style.display = 'none';
            }
            const result = e.data;
            // Chia primitives thành 4 nhóm, mỗi nhóm xử lý bởi một worker
            const CHUNK_SIZE = Math.ceil(result.length / 8);
            let completed = 0;
            const total = result.length;
            function chunkArray<T>(arr: T[], size: number): T[][] {
                const chunks: T[][] = [];
                for (let i = 0; i < arr.length; i += size) {
                    chunks.push(arr.slice(i, i + size));
                }
                return chunks;
            }
            const resultChunks = chunkArray(result, CHUNK_SIZE);
            for (const chunk of resultChunks) {
                const chunkWorkerCode = `
                    self.onmessage = function(e) {
                        const { chunk } = e.data;
                        // Trả về styleData cho các primitive trong chunk
                        self.postMessage(chunk);
                    };
                `;
                const chunkBlob = new Blob([chunkWorkerCode], { type: 'application/javascript' });
                const chunkWorker = new Worker(URL.createObjectURL(chunkBlob));
                chunkWorker.postMessage({ chunk });
                chunkWorker.onmessage = (ev) => {
                    const chunkResult = ev.data;
                    let i = 0;
                    const BATCH_SIZE = 4; // Số lượng primitive apply style mỗi frame
                    const applyBatch = () => {
                        let didUpdate = false;
                        for (let b = 0; b < BATCH_SIZE && i < chunkResult.length; b++, i++) {
                            const { primitiveIndex, styleData } = chunkResult[i];
                            if (styleData && primitives[primitiveIndex]) {
                                const currentStyle = primitives[primitiveIndex].style;
                                // So sánh style hiện tại với style mới, chỉ update nếu khác
                                let isDifferent = true;
                                try {
                                    // Chỉ so sánh phần styleData, không so sánh instance
                                    if (currentStyle && currentStyle._styleOptions) {
                                        isDifferent = JSON.stringify(currentStyle._styleOptions) !== JSON.stringify(styleData);
                                    } else if (currentStyle) {
                                        // Nếu không có _styleOptions, so sánh toàn bộ object
                                        isDifferent = JSON.stringify(currentStyle) !== JSON.stringify(styleData);
                                    }
                                } catch (e) {
                                    isDifferent = true;
                                }
                                if (isDifferent) {

                                    primitives[primitiveIndex].style = new Cesium3DTileStyle(styleData);
                                }
                            }
                            completed++;
                            didUpdate = true;
                        }
                        if (completed >= total) {

                            this.listPicked = [];
                            this.viewer.scene.requestRender();
                            chunkWorker.terminate();
                        } else if (didUpdate) {
                            requestAnimationFrame(applyBatch);
                        } else {
                            // Nếu không còn gì để update nhưng chưa đủ completed (edge case)
                            if (completed < total) {

                                this.listPicked = [];
                                this.viewer.scene.requestRender();
                            }
                            chunkWorker.terminate();
                        }
                    };
                    requestAnimationFrame(applyBatch);
                };
            }
            worker.terminate();
        };
    };



    //#region contextMenu_ShowAll
    private _firstShowAll = false

    private contextMenu_ShowAll = (contextMenu: HTMLElement) => {
        this._firstShowAll = true
        if (this.conditionsIsolate) {
            const primitives = this.viewer.scene.primitives._primitives;
            for (let i = 0; i < primitives.length; ++i) {
                primitives[i].style = null;
            }

            this.conditionsIsolate = []
        }
        this.tempCondition = {}
        this.conditionShowOff = []
        this.conditionForShowOff = []
        this._handleResetAllColor()
        this.objectOffs = [];
        this.objectIsolates = []
        this.isIsolating = false
        this.isShowOff = false

        // this._handleResetAllColor()
        this._inputDataPrimitive.resetDefaultColor()
        if (this.layerModel) {
            this.layerModel.handleShowAllElement()
        }

        contextMenu.style.display = 'none'

        this.viewer.scene.requestRender();

    };
    //#region destroyContextMenu
    destroyContextMenu = () => {
        if (this.handler) {

            this.handler.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE);
            this.handler.removeInputAction(ScreenSpaceEventType.RIGHT_CLICK);
            this.handler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
            this.handler.removeInputAction(ScreenSpaceEventType.LEFT_DOWN);
            this.handler.removeInputAction(ScreenSpaceEventType.LEFT_UP);
            this.handler.removeInputAction(ScreenSpaceEventType.RIGHT_DOWN);
            this.handler.removeInputAction(ScreenSpaceEventType.RIGHT_UP);
            this.handler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK, KeyboardEventModifier.CTRL)
        }

        // Xóa các đối tượng trong danh sách objectOffs
        this.objectOffs = [];

        // Xóa DOM của context menu
        const cesiumContainer = document.getElementById(this.containerId);
        const contextMenu = cesiumContainer?.querySelector('.cesium-context-menu');
        if (contextMenu) {
            contextMenu.remove(); // Xóa context menu khỏi DOM
        }
        this._handleResetAllColor();
        this.objectOffs = [];
        this.objectIsolates = []
        this.isIsolating = false
        this.isShowOff = false
        // Nếu không chọn gì, xóa hiệu ứng
        // if (this._edgeDetection) {
        //     this._edgeDetection.selected = [];

        // }


        this.removeEscKeyListener();
        this._removeListenEventKeyBoard()



    }
    //#region  getObjsIdsPicked
    getObjsIdsPicked = (): SelectedObjectInfo[] => {
        const objData: SelectedObjectInfo[] = [];

        this.listPicked.forEach((picked: any) => {

            const pickedGuidId = picked.feature.getProperty("Guid");
            const nameFile = picked.feature.getProperty("Primitive");
            // Kiểm tra nếu FileName đã tồn tại trong objData
            const existingEntry = objData.find(entry => entry.FileName === nameFile);

            if (existingEntry) {
                // Nếu tồn tại, kiểm tra và chỉ thêm Guid nếu chưa tồn tại
                if (!existingEntry.Guids.includes(pickedGuidId)) {
                    existingEntry.Guids.push(pickedGuidId);
                }
            } else {
                // Nếu chưa tồn tại, tạo một mục mới
                objData.push({
                    FileName: nameFile,
                    Guids: [pickedGuidId]
                });
            }
        });

        return objData;
    };

    setOnSelectionChangedCallback = (callback: (selectedIds: SelectedObjectInfo[]) => void) => {
        this.onSelectionChangedCallback = callback;
    };

    notifySelectionChanged = () => {
        if (this.onSelectionChangedCallback) {
            this.onSelectionChangedCallback(this.getObjsIdsPicked());
        }
    };




    //#region _handeListenEventKeyBoard
    private _handleKeyDown: ((event: KeyboardEvent) => void) | undefined;
    private _handleKeyUp: ((event: KeyboardEvent) => void) | undefined;

    private _handeListenEventKeyBoard = () => {
        // Gán các hàm xử lý sự kiện vào các thuộc tính của class
        this._handleKeyDown = (event: KeyboardEvent) => {
        };

        this._handleKeyUp = (event: KeyboardEvent) => {
            if (event.key === "Alt") {
                this._boxDrag!.style.display = 'none';
            }
        };

        // Đăng ký các sự kiện
        window.addEventListener("keydown", this._handleKeyDown);
        window.addEventListener("keyup", this._handleKeyUp);
    };
    //#region _removeListenEventKeyBoard
    private _removeListenEventKeyBoard = () => {
        if (this._handleKeyDown) {
            window.removeEventListener("keydown", this._handleKeyDown);
        }
        if (this._handleKeyUp) {
            window.removeEventListener("keyup", this._handleKeyUp);
        }
    };
    //#region _shareLongLat
    private _shareLongLat = (cartesian: any) => {
        if (cartesian === undefined) return
        // navigator copy clipboard
        const cartographic = Cartographic.fromCartesian(cartesian);
        const longitude = MathCesium.toDegrees(cartographic.longitude);
        const latitude = MathCesium.toDegrees(cartographic.latitude);

        navigator.clipboard.writeText(`https://www.google.com/maps?q=${latitude},${longitude}`)
    }
}
